/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ExternalCatalogColumnPatch } from './ExternalCatalogColumnPatch';

export type ExternalCatalogPatch = {
    catalogProvider?: ExternalCatalogPatch.catalogProvider;
    catalogUrl?: string;
    columns?: Array<ExternalCatalogColumnPatch>;
    customMetadataEntryIds?: Array<string>;
    description?: string;
    tagIds?: Array<string>;
};

export namespace ExternalCatalogPatch {

    export enum catalogProvider {
        ATLAN = 'ATLAN',
        ALATION = 'ALATION',
        AMUNDSEN = 'AMUNDSEN',
        APACHE_ATLAS = 'APACHE_ATLAS',
        CASTOR_DOC = 'CASTOR_DOC',
        COLLIBRA = 'COLLIBRA',
        DATAGALAXY = 'DATAGALAXY',
        INFORMATICA = 'INFORMATICA',
        SECODA = 'SECODA',
        SELECT_STAR = 'SELECT_STAR',
        CATALOG_GENERIC = 'CATALOG_GENERIC',
    }


}
